import React, { useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import {
  btag,
  constants,
  pushToDataLayer,
  sessionId,
  SessionStorageManager,
  SiteConfigManager,
  StorageManager,
  useDetection,
} from '@atlas/core';
import { staticRoutes } from '@atlas/routing';
import { Button } from '@atlas/ui';

import { CXFROM_STORAGE_KEY, DATA_LAYER_STORAGE_KEYS } from 'common/constants';
import { useSignupPopup } from 'src/components/Auth/useSignUpPopup';

const HeaderNonAutorized = ({ twoButton }) => {
  const { pathname } = useLocation();

  const showSignIn = pathname !== staticRoutes.signin;
  const showSignUp = pathname !== staticRoutes.signup;
  const signUpPopup = SiteConfigManager.getConfig('config.config.registration.showInPopup', false);

  const { openSignupPopup } = useSignupPopup();
  const { browser, ip, locale, os } = useDetection();

  const isRegistrationButtonClicked = SessionStorageManager.getItem(
    DATA_LAYER_STORAGE_KEYS.REGISTRATION_BUTTON_CLICKED,
  );

  const sendRegistrationButtonClickEvent = useCallback(() => {
    pushToDataLayer(
      'registration_button_click',
      {
        OS: os,
        browser,
        created_at: Date.now(),
        device: constants.DEVICE_TYPES.MOBILE,
        ip,
        locale,
        page_referer: window.location.pathname,
        session_id: sessionId,
      },
      btag,
    );
    SessionStorageManager.setItem(DATA_LAYER_STORAGE_KEYS.REGISTRATION_BUTTON_CLICKED, true);
  }, [browser, ip, locale, os]);

  const handleSignInClick = useCallback(() => {
    if (pathname !== staticRoutes.signup) {
      StorageManager.setItem(CXFROM_STORAGE_KEY, pathname);
    }
  }, [pathname]);

  const onSignUpClick = useCallback(() => {
    StorageManager.removeItem(CXFROM_STORAGE_KEY);
    openSignupPopup();
    if (isRegistrationButtonClicked) return;
    sendRegistrationButtonClickEvent();
  }, [sendRegistrationButtonClickEvent, openSignupPopup, isRegistrationButtonClicked]);

  if (twoButton) {
    return (
      <div className="header-button-block two-button">
        {showSignIn && (
          <Link onClick={handleSignInClick} to={staticRoutes.signin}>
            <Button block label="Sign in" size="small" type="text" />
          </Link>
        )}
        {showSignUp &&
          (signUpPopup ? (
            <Button
              block
              className="two-button-signup"
              label="Sign up"
              onClick={onSignUpClick}
              size="small"
              type="text"
            />
          ) : (
            <Link
              onClick={() => {
                StorageManager.removeItem(CXFROM_STORAGE_KEY);
                sendRegistrationButtonClickEvent();
              }}
              to={staticRoutes.signup}
            >
              <Button block label="Sign up" size="small" type="text" />
            </Link>
          ))}
      </div>
    );
  }

  return (
    <div className="header-button-block">
      {showSignIn && (
        <Link onClick={handleSignInClick} to={staticRoutes.signin}>
          <Button block label="Sign in" size="medium" type="primary" />
        </Link>
      )}
    </div>
  );
};

export default HeaderNonAutorized;

HeaderNonAutorized.propTypes = { twoButton: PropTypes.bool };
